import { render } from "./EditDocument.vue?vue&type=template&id=64081d04"
import script from "./EditDocument.vue?vue&type=script&lang=js"
export * from "./EditDocument.vue?vue&type=script&lang=js"

import "./EditDocument.vue?vue&type=style&index=0&id=64081d04&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__